import PropTypes from "prop-types";
import React, {Component} from "react";
import {TextInput, View, StyleSheet} from "react-native";
import {Dimensions} from "react-native";
const { width } = Dimensions.get("window");

const propTypes = {
    mapElement: PropTypes.func,
    onSubmitEditing: PropTypes.func,
    onChangeText: PropTypes.func,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    keyboardType: PropTypes.string,
    secureTextEntry: PropTypes.bool,
    label: PropTypes.string
};

const defaultProps = {
    mapElement: (n) => {},
    onSubmitEditing: () => {},
    onChangeText: () => {},
    value: "",
    placeholder: "",
    maxLength: 200,
    keyboardType: "default",
    secureTextEntry: false,
    label: ""
};

const styles = StyleSheet.create({
  inputBox: {
    width:300,
    backgroundColor:'rgba(255, 255,255,0.2)',
    borderRadius: 25,
    fontSize:16,
    fontFamily:"SourceSansPro-Regular"
  },
  emailtextInput:{width:width/1.4,marginLeft:15,height:50},
  textboxfieldd:{fontFamily:"SourceSansPro-Regular"}

});

class InputTextTemplate extends Component {

    state = {
        value: ""
    }

    componentDidMount() {
        this.setState({
            value: this.props.value
        });
    }

    onChangeText = (value) => {
        this.setState({
            value
        }, () => {
            this.props.onChangeText(value);
        })
    }

    render() {
        const {placeholder, secureTextEntry, keyboardType, maxLength, value, onChangeText, onSubmitEditing} = this.props;
        return (
            <View>
                <TextInput
                    style={styles.emailtextInput}
                    placeholder={placeholder}
                    secureTextEntry={secureTextEntry}
                    keyboardType={keyboardType}
                    maxLength={maxLength}
                    returnKeyType="next"
                    // value={this.state.value}
                    onSubmitEditing={onSubmitEditing}
                    placeholderStyle={styles.textboxfieldd}
                    // placeholderTextColor="#2C393F"
                    onChangeText={this.onChangeText} />
           </View>
        );
    }
}

InputTextTemplate.defaultProps = defaultProps;

InputTextTemplate.propTypes = propTypes;

export default InputTextTemplate;